import { render, staticRenderFns } from "./home.vue?vue&type=template&id=463d4c8f&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=463d4c8f&scoped=true&lang=css&"
import style1 from "./home.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463d4c8f",
  null
  
)

export default component.exports